Vendd.Scripts.load(function () {

	// if (!isTouch()) {
		$(".x-timeline-box").each(function( index ) {
			var $box = $(this);
			if(index == 0){
				$box.addClass("active visited");
			}
			var $intro = $box.find(".intro");
			if($intro.length){
				var ih = parseInt($intro.outerHeight());
				$box.css("min-height",ih * 2 + 60);
			}
		}).promise().done( function(){  
	        $(".x-timeline-box").waypoint(function(direction) {
				$(".x-timeline-box").removeClass("active");
				$("#" + this.element.id).addClass("active visited");
			}, { offset: "25%" });
	    });
	// }
	
});
